import './helpers.css'
import { Style, Fill, Stroke } from 'ol/style';
import { transform } from 'ol/proj';


  /**
 *
 * @param {*} titulo
 * @param {*} descripcion
 * @param {*} isOpen
 * @param {*} grupo
 * @returns
 */
export function crearAcordeon (titulo, descripcion, isOpen = false, grupo = null) {
  const isOpenClass = isOpen ? 'open' : '' // Check the value of isOpen

  // Variable para almacenar el icono y el nombre del grupo si el grupo no es nulo
  const nombreGrupo = grupo !== null ? `<strong>${grupo}</strong><br>` : ''

  return `
    <div class="acordeon-container">
      <details ${isOpenClass}>
        <summary>
          <div className='accordion-summary'>
            // <LayersIcon />
            ${nombreGrupo} 
            ${titulo}
          </div>
        </summary>
        <div class='sidebarLayers'>
          ${descripcion}
        </div>
      </details>
    </div>
  `
}




// 🔹 Función para detectar si el valor es una fecha
// Ejemplos de fechas que ahora serán válidas:
// ✅ "2025-02-27T10:07:43Z"
// ✅ "2025-02-27T10:07:43.123Z"
// ✅ "2025-02-27T10:07:43.123456Z"
// ✅ "2025-02-27T10:07:43"
// ✅ "2025-02-27 10:07:43"
// ✅ "2025-02-27"
export function isValidDate(string) {
  const dateTimeRegex = /^\d{4}-\d{2}-\d{2}(?:Z|T\d{2}:\d{2}:\d{2}(?:\.\d{1,6})?Z?|\s\d{2}:\d{2}:\d{2})?$/;
  return dateTimeRegex.test(string);
}



export function formatDate(value) {
  if (!value) return "";

  // Extraer la parte YYYY-MM-DD sin que JS haga conversión de zona horaria
  const match = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (match) {
    // Convertir de YYYY-MM-DD a DD/MM/YYYY
    const year = match[1];
    const month = match[2];
    const day = match[3];
    return `${day}/${month}/${year}`;
  }
  return "";
}

/**
 * Refresca la capa identificada por su nombre (`name`).
 * @param {ol/Map} map - Instancia de OpenLayers Map.
 * @param {string} name - Nombre asignado con layer.set('name', ...).
 * @returns {boolean} true si se refrescó, false si no.
 */
export const refreshLayerByName = (map, name) => {
  if (!map) return false;

  console.log(`🔄 Refrescando capa con nombre "${name}"...`);

  const layer = map.getLayers().getArray().find(l => l.get('name') === name);
  if (layer && typeof layer.getSource === 'function') {
    const source = layer.getSource();
    if (source?.refresh) {
      source.refresh();
      console.log(`✅ Capa con nombre "${name}" refrescada.`);
      return true;
    }else{
      console.warn(`⚠️ La capa "${name}" no tiene método refresh.`);
      return false;
    }
  }

  console.warn(`⚠️ No se pudo refrescar la capa con nombre "${name}".`);
  return false;
};

// Re-export addIncidenceToLayer from separate file
export { addIncidenceToLayer } from './addIncidenceToLayer';



/**
 * Devuelve una capa del mapa por su ID personalizado.
 * @param {ol/Map} map - Instancia de OpenLayers Map.
 * @param {string} id - ID asignado a la capa con layer.set('id', ...).
 * @returns {ol/layer/Layer|null} La capa encontrada o null si no existe.
 */
export const getLayerById = (map, id) => {
  if (!map) return null;

  return map.getLayers()
    .getArray()
    .find(layer => layer.get('id') === id) || null;
};


/**
 * Devuelve un array con todas las capas visibles en el mapa.
 * @param {ol/Map} map - Instancia del mapa de OpenLayers.
 * @returns {Array<ol/layer/Layer>} Array de capas visibles.
 */
export const getVisibleLayers = (map) => {
  if (!map) return [];

  return map.getLayers()
    .getArray()
    .filter(layer => layer.getVisible());
};


/**
 * Muestra en consola el ID y nombre de todas las capas visibles del mapa.
 * @param {ol/Map} map - Instancia del mapa de OpenLayers.
 */
export const logVisibleLayers = (map) => {
  if (!map) {
    console.warn('⚠️ No se ha proporcionado una instancia de mapa.');
    return;
  }

  const visibles = map.getLayers()
    .getArray()
    .filter(layer => layer.getVisible());

  if (visibles.length === 0) {
    console.log('ℹ️ No hay capas visibles en el mapa.');
    return;
  }

  console.log('🔍 Capas visibles:');
  visibles.forEach(layer => {
    console.log(`🟢 id: ${layer.get('id') || '—'}, name: ${layer.get('name') || '—'}`);
  });
};

/**
 * Refresca todas las capas visibles de tipo GeoJSON (con método refresh).
 * @param {ol/Map} map - Instancia del mapa de OpenLayers.
 */
export const refreshVisibleGeojsonLayers = (map) => {
  if (!map) {
    console.warn('⚠️ No se ha proporcionado una instancia de mapa.');
    return;
  }

  const layers = map.getLayers().getArray();

  layers
    .filter(layer => layer.getVisible())
    .forEach(layer => {
      const source = layer.getSource?.();
      const name = layer.get('name') || '—';

      if (typeof source?.refresh === 'function') {
        console.log(`🔁 Refrescando capa GeoJSON visible: ${name}`);
        source.refresh();
      } else {
        console.log(`⏭️ Ignorada: ${name} (no es GeoJSON o no tiene refresh)`);
      }
    });
};


 // Estilo temporal para destacar la geometría editada.
 export const getEditStyle = () =>
  new Style({
    fill: new Fill({ color: 'rgba(206, 255, 82, 0.15)' }),
    stroke: new Stroke({ color: '#405114', width: 3 }),
  });

/**
 * Añade opacidad a un color RGB para convertirlo a RGBA
 * @param {string} rgbColor - Color en formato RGB (ej: "rgb(220, 53, 69)")
 * @param {number} opacity - Valor de opacidad (0-1)
 * @returns {string} Color en formato rgba
 */
export const addOpacityToRgb = (rgbColor, opacity = 1) => {
  const rgbValues = rgbColor.match(/\d+/g);
  if (!rgbValues || rgbValues.length < 3) return rgbColor;
  return `rgba(${rgbValues[0]}, ${rgbValues[1]}, ${rgbValues[2]}, ${opacity})`;
};

// Busca una capa cargada por nombre.
export const getLayerByName = (map, name) => {
  return map.getLayers().getArray().find((layer) => layer.get('name') === name) || null;
};

// Busca una feature por su ID dentro de una fuente.
export const getFeatureById = (source, id) => {
  return source.getFeatures().find(
    (f) => f.getId() === id || f.get('id') === id
  ) || null;
};

// Restaura el estilo original de la feature.
export const resetFeatureStyle = (feature) => {
  if (feature) feature.setStyle(null);
};


/** Función para obtener las coordenadas de un feature y centrar el mapa en ellas
 * 
 * @param {*} e 
 * @param {*} feature 
 */
export function getCoordinatesAndCenter(e, feature, setCoordinatesToCenter) {
    e.preventDefault()
    let coordinates

    // Lógica para obtener las coordenadas según el tipo de feature
    if (feature.x && feature.y) {
        coordinates = [feature.x, feature.y]
    } else if (feature.geometry && feature.geometry.getExtent) {
        const extent = feature.geometry.getExtent()
        const centerX = (extent[0] + extent[2]) / 2
        const centerY = (extent[1] + extent[3]) / 2

        // Convertir el centro del extent de EPSG:3857 a EPSG:4326
        const transformedCenter = transform([centerX, centerY], 'EPSG:3857', 'EPSG:4326');
        coordinates = transformedCenter; // Usamos las coordenadas transformadas

    } else if (feature.geometry && feature.geometry.getCoordinates) {
        const centroid = feature.geometry.getCoordinates().getInteriorPoint().getCoordinates()
        coordinates = centroid
    }

    if (coordinates) {
        setCoordinatesToCenter(coordinates)
    }
}




